/**
 * Plain-language "waarom deze taak?" bullets (roadmap §3 task card
 * requirement). The engine (class-etm-engine.php) doesn't return a score
 * breakdown over the wire, so this reconstructs a qualitative — not exact
 * numeric — explanation from the same fields ETM_Engine::score() weighs.
 * Good enough for "why this one", not a claim of the literal formula.
 */
import { __ } from '../i18n.js';
import { parseServerDate } from './format.js';

export function explainTask(task, availableMinutes) {
  const reasons = [];
  const priority = Number(task.priority) || 0;
  const impact = Number(task.impact) || 0;
  const effort = Number(task.effort_minutes) || 0;

  if (priority >= 3) {
    reasons.push(__('Je gaf deze taak een hoge prioriteit.', 'etm'));
  }
  if (impact >= 3 && effort > 0 && effort <= 60) {
    reasons.push(__('Hoge impact voor relatief weinig tijd.', 'etm'));
  }
  if (task.deadline) {
    reasons.push(
      task.deadline_type === 'hard'
        ? __('Heeft een harde deadline die nadert.', 'etm')
        : __('Heeft een streefdatum die nadert.', 'etm')
    );
  }
  if (task.reward) {
    reasons.push(__('Er staat een beloning op deze taak.', 'etm'));
  }
  if (availableMinutes && effort && effort / availableMinutes >= 0.6) {
    reasons.push(__('Past goed bij de tijd die je nu hebt.', 'etm'));
  }
  const created = parseServerDate(task.created_at);
  if (created && (Date.now() - created.getTime()) / 86400000 >= 14) {
    reasons.push(__('Staat al een tijdje op je lijst.', 'etm'));
  }
  if (reasons.length === 0) {
    reasons.push(__('Past goed binnen je gekozen categorie en tijd.', 'etm'));
  }
  return reasons;
}
